import { isBrowser } from 'react-device-detect';

export const mapShouldUseWidth =
  isBrowser && window.innerWidth > window.innerHeight;

export const MAP_UNIT = mapShouldUseWidth ? 'vw' : 'vh';
export const MAP_SIZE_CURRENT = mapShouldUseWidth ? 6 : 12;
export const MAP_SIZE_OTHER_PROFILE = mapShouldUseWidth ? 4.5 : 9;
export const MAP_SPACE_BETWEEN_CIRCLES = mapShouldUseWidth ? 3 : 6;
